import React, { useEffect, useState } from "react";
import { getUsers } from "../../service/endpoint-manager";
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  InputLabel,
} from "@mui/material";
import UserSelectField from "./Shared/Inputs/UserSelectFieldv2";

function UserList({ selectedUser, setSelectedUser }) {
  const handleUserChange = (event) => {
    setSelectedUser(event.user_id);
  };

  return (
    <FormControl style={{ width: "70%" }}>
      <InputLabel id="unit-select-label" style={{ marginTop: "8px" }}>
        Observer
      </InputLabel>
      <UserSelectField
        optionLabel={`observer`}
        optionValue={`observer`}
        userId={selectedUser}
        initiallySelectedUser={null}
        handleUserChange={handleUserChange}
        name={`observer`}
        title={"Observer"}
        isFormik={false}
      />
    </FormControl>
  );
}

export default UserList;
